import React, { PropTypes } from "react";
import InputField from "components/InputField/InputField";
import SelectField from "components/InputField/SelectField";
import CountyInput from "containers/Input/CountyInput";
import TextField from "material-ui/TextField";
import FileField from "components/InputField/FileField";
import Checkbox from "material-ui/Checkbox";
import BranchInput from "containers/Input/BranchInput";
import CountryInput from "containers/Input/CountryInput";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControl, FormControlLabel, FormLabel } from "material-ui/Form";
import Select from "react-select";

const labels = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email",
  user_type: "I am a",
  imc: "IMC Number",
  registration: "Accreditation Number",
  practice_name: "Practice Name",
  phone: "Phone",
  hospital: "Hospital",
  title: "Title",
  profession: "Profession",
  ipna_member: "IGPNEA (IPNA)",
  branch: "Branch",
  country: "Country",
  accreditation: "Accreditation",
  pin_number: "NMBI PIN Number",
  discipline: "Discipline",
  new_user_type: "I am a",
  new_disciplines: "Discipline",
  password: "Password",
  sponsor_type: "Sponsor Type",
  registration_number: "Registration Number",
  company_name: "Company name",
  position: "Position/role in the company",
};

const allRoles = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "nurse", label: "Nurse" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  // {},
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  { value: "pharmacist", label: "Pharmacy" },
  // { value: "midwifery", label: "Midwife" },
  { value: "industry", label: "Industry" },
];

const userTypeToChangeRoles = [
  { value: "midwifery", label: "Midwife" },
  { value: "nurse", label: "Nurse" },
];

const roleLabel = {
  gp: { value: "gp", label: "GP" },
  gp_trainee: { value: "gp_trainee", label: "GP Trainee" },
  nurse: { value: "nurse", label: "Nurse" },
  consultant: { value: "consultant", label: "Consultant" },
  hospital_doctor: {
    value: "hospital_doctor",
    label: "NCHD (Hospital Doctor)",
  },
  nurse_specialist: {
    value: "nurse_specialist",
    label: "Nurse Specialist/ANP",
  },
  allied_healthcare_professional: {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  pharmacist: { value: "pharmacist", label: "Pharmacy" },
  // midwifery: { value: "midwifery", label: "Midwife" },
  industry: { value: "industry", label: "Industry" },
};

const sponsorTypes = [
  {
    value: 0,
    label: "Pharmaceutical",
  },
  {
    value: 1,
    label: "Private Hospital",
  },
];

const sponsorTypeLabel = {
  pharmaceutical: 0,
  private_hospital: 1,
};

const rolesMap = {
  // 'gp_trainee': [{value: 'gp', label: 'GP'}],
  admin: allRoles,
};

const rolesByApproveMap = {
  hospital_doctor: [
    { value: "gp", label: "GP" },
    { value: "gp_trainee", label: "GP Trainee" },
    { value: "consultant", label: "Consultant" },
  ],
  gp_trainee: [{ value: "gp", label: "GP" }],
};

const titles = [
  { label: "Dr.", value: "dr" },
  { label: "Mr.", value: "mr" },
  { label: "Ms.", value: "ms" },
  { label: "Mrs.", value: "mrs" },
  { label: "Prof.", value: "prof" },
];

const disciplineNumberByRole = {
  gp: 1,
  gp_trainee: 1,
  nurse: 1,
  consultant: 5,
  hospital_doctor: 5,
  allied_healthcare_professional: 1,
  pharmacist: 9,
  nurse_specialist: 5,
  // midwifery: 1,
};

const Profile = ({
  user,
  userProps,
  approveIpna,
  user: {
    first_name,
    last_name,
    email,
    password,
    user_type,
    country,
    county,
    phone,
    title,
    notification_enabled,
    email_confirmed,
    company_name,
    ipna_member,
    branch,
    update_ipna,
    update_type,
    accreditation,
    discipline,
    new_user_type,
    new_disciplines,
    sponsor_type,
    show_id_number,
    // is_representative,
  },
  errors,
  onFieldChange,
  onSubmit,
  onRoleChange,
  onCountyChange,
  onIpnaChange,
  internationRoleFields,
  irishRoleFields,
  onBranchChange,
  onAccreditaionChange,
  onCountryChange,
  is_admin,
  onSelectChangeDiscipline,
  onSelectChangeNewDiscipline,
  onNewDisciplinesApprove,
  onIpnaApprove,
  onApproveIpnaChange,
  onApproveIpnaBranchChange,
  disciplines = [],
  newDisciplines = [],
  buttonUserTypeAndDisciplinesConfirmationDisabled,
  buttonIpnaConfirmationDisabled,
  numberOfNewDisciplinesAllowedByUserType,
  isSponsorForm,
  // onRepresentativeChange,
  handleIsUserSuperhost,
  onShowIdNumberChange,
}) => {
  //const hideMoreValue = hideMore(user, onCountyChange);
  const localStorageUser =
    JSON.parse(localStorage.user) && JSON.parse(localStorage.user).user_type
      ? JSON.parse(localStorage.user)
      : user;
  const localStorageUserDisciplines = localStorageUser.disciplines || [];
  const isUserWithoutDisciplines = !(
    localStorageUserDisciplines && localStorageUserDisciplines.length
  );
  const userType = localStorageUser.user_type;

  const canChangeUserType =
    userType === "midwifery" ||
    userType === "registered_general_nurses" ||
    userType === "practice_nurse";

  const canChangeDisciplines =
    [
      "consultant",
      "hospital_doctor",
      "nurse_specialist",
      "midwifery",
      "registered_general_nurses",
      "practice_nurse",
      "nurse",
    ].indexOf(userType) > -1;

  const isDisciplinesDisabled = !(
    isUserWithoutDisciplines ||
    canChangeDisciplines ||
    is_admin
  );

  const roles =
    is_admin || !userType
      ? allRoles
      : canChangeUserType
        ? userTypeToChangeRoles
        : [roleLabel[userType]];

  const isUserTypeSelectDisabled =
    userType &&
    [
      "gp_trainee",
      "admin",
      "midwifery",
      "registered_general_nurses",
      "practice_nurse",
      "nurse",
    ].indexOf(userType) === -1 &&
    !is_admin;

  const rolesByApprove = (userType && rolesByApproveMap[userType]) || [];

  const showDisciplines =
    (userType &&
      ["gp", "gp_trainee", "pharmacist", "industry"].indexOf(userType) ===
        -1) ||
    is_admin;
  const sponsorType =
    sponsorTypeLabel[sponsor_type] || sponsorTypeLabel[sponsor_type] === 0
      ? sponsorTypeLabel[sponsor_type]
      : sponsor_type;

  return (
    <div className="container_form">
      <div className="section_form row">
        <form className="col s12" onSubmit={onSubmit}>
          <div className="row">
            {isSponsorForm && (
              <FileField
                className="col s12"
                field_name="avatar"
                onChange={onFieldChange}
                label={labels["avatar"]}
                errors={errors["avatar"]}
              />
            )}
            <SelectField
              className="col s12"
              label={labels["title"]}
              onChange={onFieldChange}
              errors={errors["title"]}
              autoComplete="new-password"
              field_name="title"
              value={title}
              options={titles}
            />
            {[
              {
                field_name: "first_name",
                value: first_name,
                className: "col s12 m6",
              },
              {
                field_name: "last_name",
                value: last_name,
                className: "col s12 m6",
              },
              {
                field_name: "email",
                value: email,
                type: "email",
                className: "col s12",
              },
              is_admin
                ? {
                    field_name: "password",
                    value: password,
                    type: "password",
                    className: "col s12",
                  }
                : {},
            ].map(
              (e) =>
                e.field_name && (
                  <InputField
                    className="col s12"
                    label={labels[e.field_name]}
                    onChange={onFieldChange}
                    errors={errors[e.field_name]}
                    autoComplete="new-password"
                    {...e}
                  />
                ),
            )}
            {["sponsor"].indexOf(user.user_type) === -1 && (
              <div>
                <SelectField
                  className="col s12"
                  label={labels["user_type"]}
                  onChange={onRoleChange}
                  errors={errors["user_type"]}
                  autoComplete="new-password"
                  field_name="user_type"
                  value={user_type || user.user_type || userType || ""}
                  options={roles}
                  disabled={isUserTypeSelectDisabled}
                />
                {((user.disciplines && user.disciplines.length) ||
                  (disciplines && disciplines.length)) &&
                showDisciplines ? (
                  <p>
                    <Select
                      className="col s12"
                      placeholder="Select discipline"
                      value={
                        user.disciplines &&
                        user.disciplines.map((discipline) => ({
                          value: discipline.id || discipline.value,
                          label: discipline.title || discipline.label,
                        }))
                      }
                      onChange={onSelectChangeDiscipline}
                      multi={true}
                      options={
                        disciplines &&
                        disciplines.map((discipline) => ({
                          value: discipline.id,
                          label: discipline.title,
                        }))
                      }
                      disabled={isDisciplinesDisabled}
                    />
                    {user_type && !isDisciplinesDisabled ? (
                      <div>{`Number of disciplines allowed for ${
                        allRoles.find((role) => role.value === user_type).label
                      }: ${disciplineNumberByRole[user_type]}`}</div>
                    ) : (
                      ""
                    )}
                  </p>
                ) : (
                  ""
                )}
              </div>
            )}

            {user.user_type != "sponsor" ? (
              <div className="col s12 accreditaion_select">
                <FormControl>
                  <p>Accreditation</p>
                  <RadioGroup
                    onChange={onAccreditaionChange}
                    value={user.accreditation}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" />}
                      label="Irish"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" />}
                      label="International"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            ) : null}
            {is_admin && user.user_type !== "sponsor" && (
              <div className="col s12 accreditaion_select">
                <FormControl>
                  <p>Superhost</p>
                  <RadioGroup
                    onChange={handleIsUserSuperhost}
                    value={user.role === "superhost"}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            )}
            {user.user_type != "sponsor" &&
            (user.user_type === "nurse" ||
              user.user_type === "practice_nurse") ? (
              <div className="col s12 ipna_select">
                <FormControl>
                  <p>I am an IGPNEA member</p>
                  <RadioGroup
                    //value={webinar.webinar_type}
                    className={is_admin ? "" : "disabled-style"}
                    onChange={onIpnaChange}
                    value={user.ipna_member}
                    disabled={true}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            ) : null}
            {isSponsorForm && is_admin && (
              <div className="col s12 ipna_select">
                <FormControl>
                  <p>Show IMC/NMBI Numbers</p>
                  <RadioGroup
                    onChange={onShowIdNumberChange}
                    value={show_id_number}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            )}
            {/* {isSponsorForm && is_admin && (
              <div className="col s12 ipna_select">
                <FormControl>
                  <p>Representative</p>
                  <RadioGroup
                    onChange={onRepresentativeChange}
                    value={is_representative}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            )} */}

            {user.user_type != "sponsor" && user.ipna_member ? (
              <div className={is_admin ? "tal" : "tal disabled-style"}>
                <BranchInput
                  value={branch}
                  onChange={onBranchChange}
                  errors={errors["county"]}
                  className="col s12"
                />
              </div>
            ) : null}

            {!user.accreditation && user.user_type != "sponsor" ? (
              <div className="tal">
                <CountryInput
                  value={country}
                  onChange={onCountryChange}
                  errors={errors["country"]}
                  className="col s12"
                />
              </div>
            ) : null}
            {/*{is_admin && user.user_type = 'practice_nurse'  ?*/}
            {is_admin &&
            user.user_type !== "hospital_doctor" &&
            user.user_type !== "consultant" &&
            user.user_type !== "nurse" &&
            user.user_type !== "nurse_specialist" &&
            user.user_type !== "gp" &&
            user.user_type !== "gp_trainee" &&
            user.user_type !== "allied_healthcare_professional" &&
            user.user_type !== "industry" &&
            user.user_type != "sponsor" ? (
              <InputField
                className="col s12"
                label={labels["practice_name"]}
                onChange={onFieldChange}
                errors={errors["practice_name"]}
                autoComplete="new-password"
                value={user["practice_name"]}
                field_name={"practice_name"}
              />
            ) : (
              ""
            )}
            {user.user_type != "sponsor" && user.accreditation
              ? irishRoleFields.map((field) => (
                  <InputField
                    className="col s12"
                    label={labels[field]}
                    onChange={onFieldChange}
                    errors={errors[field]}
                    autoComplete="new-password"
                    value={user[field] || ""}
                    field_name={field}
                  />
                ))
              : internationRoleFields.map((field) => (
                  <InputField
                    className="col s12"
                    label={labels[field]}
                    onChange={onFieldChange}
                    errors={errors[field]}
                    autoComplete="new-password"
                    value={user[field] || ""}
                    field_name={field}
                  />
                ))}

            {user.user_type === "sponsor" && (
              <InputField
                className="col s12"
                label="Company"
                onChange={onFieldChange}
                errors={errors["company_name"]}
                autoComplete="new-password"
                value={user.company_name}
                field_name={"company_name"}
              />
            )}

            {user.accreditation && user.user_type != "sponsor" ? (
              <div>
                <CountyInput
                  value={county}
                  onChange={onCountyChange}
                  errors={errors["county"]}
                />
              </div>
            ) : null}

            {is_admin && user.user_type != "sponsor" ? (
              <InputField
                className="col s12"
                label="Age"
                value={user.age}
                onChange={onFieldChange}
                errors={errors["age"]}
                field_name={"age"}
              />
            ) : null}
            {is_admin && user.user_type === "sponsor" && (
              <SelectField
                className="col s12"
                label={labels["sponsor_type"]}
                onChange={onFieldChange}
                errors={errors["sponsor_type"]}
                autoComplete="new-password"
                field_name="sponsor_type"
                value={sponsorType}
                options={sponsorTypes}
              />
            )}

            <InputField
              className="col s12"
              label={labels["phone"]}
              onChange={onFieldChange}
              errors={errors["phone"]}
              autoComplete="new-password"
              value={phone}
              field_name={"phone"}
            />
            {!is_admin && (
              <div className="col s12 email_notification">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={notification_enabled}
                      name="notification_enabled"
                      onChange={() =>
                        onFieldChange({
                          target: {
                            name: "notification_enabled",
                            value: !notification_enabled,
                          },
                        })
                      }
                    />
                  }
                  label={
                    <span className="email_notification_label">
                      <span>Send webinar reminders via email</span>
                      <span>
                        You won't receive email reminders 1 hour and 24 hours
                        before the webinar starts if you uncheck this box.
                      </span>
                    </span>
                  }
                />
              </div>
            )}
            {is_admin && (
              <div className="col s12 email_notification">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={email_confirmed}
                      name="notification_enabled"
                      onChange={() =>
                        onFieldChange({
                          target: {
                            name: "email_confirmed",
                            value: !email_confirmed,
                          },
                        })
                      }
                    />
                  }
                  label={
                    <span className="email_notification_label">
                      <span>Email confirmed</span>
                      <span></span>
                    </span>
                  }
                />
              </div>
            )}

            <div className="submit_center col s12">
              <input className="sign" type="submit" name="" value="Update" />
              <label></label>
            </div>
            {!is_admin && (
              <div
                className="submit_center col s12"
                style={{ marginTop: "15px" }}
              >
                <a href="#change_password">&nbsp;</a>
              </div>
            )}
          </div>
        </form>

        {rolesByApprove && rolesByApprove.length > 0 && !is_admin ? (
          <div>
            <h2 className="main_title" id="change_discipline">
              UPDATING USER TYPES
            </h2>
            <SelectField
              className="col s12"
              label={labels["new_user_type"]}
              onChange={onRoleChange}
              errors={errors["new_user_type"]}
              autoComplete="new-password"
              field_name="new_user_type"
              value={user.new_user_type || ""}
              options={rolesByApprove}
            />
            <div
              className="submit_center col s12 approve-new-disciplines-button"
              onClick={onNewDisciplinesApprove}
            >
              <input
                className="sign"
                type="submit"
                disabled={
                  userProps.update_type ||
                  buttonUserTypeAndDisciplinesConfirmationDisabled
                }
                name=""
                value={
                  userProps.update_type ||
                  buttonUserTypeAndDisciplinesConfirmationDisabled
                    ? "Requested"
                    : "Approve User"
                }
              />
            </div>
          </div>
        ) : (
          ""
        )}

        {!is_admin && user.user_type === "practice_nurse" ? (
          <div>
            <h2 className="main_title" id="change_discipline">
              UPDATING USER IGPNEA
            </h2>
            <div className="col s12 ipna_select">
              <FormControl>
                <p>I am an IGPNEA member</p>
                <RadioGroup
                  //value={webinar.webinar_type}
                  onChange={onApproveIpnaChange}
                  value={approveIpna.ipna}
                  row
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio color="primary" />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            {user.user_type != "sponsor" && approveIpna.ipna ? (
              <div className="tal">
                <BranchInput
                  value={approveIpna.branch}
                  onChange={onApproveIpnaBranchChange}
                  errors={errors["county"]}
                  className="col s12"
                />
              </div>
            ) : null}
            <div
              className="submit_center col s12 approve-new-disciplines-button"
              onClick={onIpnaApprove}
            >
              <input
                className="sign"
                type="submit"
                disabled={
                  userProps.update_ipna || buttonIpnaConfirmationDisabled
                }
                name=""
                value={
                  userProps.update_ipna || buttonIpnaConfirmationDisabled
                    ? "Requested"
                    : "Approve IGPNEA"
                }
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

Profile.propTypes = {
  user: PropTypes.object,
  errors: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onRoleChange: PropTypes.func,
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js